/**
 * Store Details Section
 * Handles image gallery lightbox and mobile swiper
 */

(function() {
  'use strict';

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', initStoreDetails);

  function initStoreDetails() {
    const section = document.querySelector('.store-details');
    if (!section) return;

    initMobileGallery(section);
    initLightbox(section);
    initGtmTracking(section);
  }

  function initGtmTracking(section) {
    section.addEventListener('click', (e) => {
      const el = e.target.closest('[data-gtm-event]');
      if (!el) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: el.getAttribute('data-gtm-event') });
    });
  }

  /**
   * Initialize Mobile Gallery with Thumbnails
   */
  function initMobileGallery(section) {
    const thumbnails = section.querySelectorAll('[data-thumbnail-index]');
    const mainImages = section.querySelectorAll('[data-mobile-image]');

    if (thumbnails.length === 0 || mainImages.length === 0) return;

    // Set first thumbnail as active
    if (thumbnails.length > 0) {
      thumbnails[0].classList.add('is-active');
    }

    // Add click handlers to thumbnails
    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', () => {
        const index = parseInt(thumbnail.getAttribute('data-thumbnail-index'), 10);

        // Update main image
        mainImages.forEach((img, i) => {
          img.classList.toggle('is-active', i === index);
        });

        // Update thumbnail active state
        thumbnails.forEach((thumb, i) => {
          thumb.classList.toggle('is-active', i === index);
        });
      });
    });
  }

  /**
   * Initialize Lightbox
   */
  function initLightbox(section) {
    const lightbox = section.querySelector('[data-lightbox-modal]');
    const triggers = section.querySelectorAll('[data-lightbox-trigger]');
    const closeBtn = section.querySelector('[data-lightbox-close]');
    const prevBtn = section.querySelector('[data-lightbox-prev]');
    const nextBtn = section.querySelector('[data-lightbox-next]');
    const slides = section.querySelectorAll('[data-lightbox-slide]');
    const counter = section.querySelector('[data-lightbox-counter]');

    if (!lightbox || triggers.length === 0) return;

    let currentIndex = 0;
    const totalSlides = slides.length;

    // Open lightbox on image click
    triggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const index = parseInt(trigger.getAttribute('data-image-index'), 10);
        openLightbox(index);
      });
    });

    // Close lightbox
    closeBtn?.addEventListener('click', closeLightbox);

    // Navigation
    prevBtn?.addEventListener('click', showPrev);
    nextBtn?.addEventListener('click', showNext);

    // Keyboard navigation
    document.addEventListener('keydown', handleKeydown);

    // Close on background click
    lightbox.addEventListener('click', (e) => {
      if (e.target === lightbox) {
        closeLightbox();
      }
    });

    function openLightbox(index) {
      currentIndex = index;
      showSlide(currentIndex);
      lightbox.classList.add('is-active');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      lightbox.classList.remove('is-active');
      document.body.style.overflow = '';
    }

    function showSlide(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });
      updateCounter();
      updateNavVisibility();
    }

    function showPrev() {
      currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
      showSlide(currentIndex);
    }

    function showNext() {
      currentIndex = (currentIndex + 1) % totalSlides;
      showSlide(currentIndex);
    }

    function updateCounter() {
      if (counter) {
        counter.textContent = `${currentIndex + 1} / ${totalSlides}`;
      }
    }

    function updateNavVisibility() {
      // Hide prev/next if only 1 image
      if (totalSlides <= 1) {
        prevBtn?.style.setProperty('display', 'none');
        nextBtn?.style.setProperty('display', 'none');
      }
    }

    function handleKeydown(e) {
      if (!lightbox.classList.contains('is-active')) return;

      switch (e.key) {
        case 'Escape':
          closeLightbox();
          break;
        case 'ArrowLeft':
          showPrev();
          break;
        case 'ArrowRight':
          showNext();
          break;
      }
    }

    // Touch swipe support for lightbox
    let touchStartX = 0;
    let touchEndX = 0;

    lightbox.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    lightbox.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          showNext(); // Swipe left
        } else {
          showPrev(); // Swipe right
        }
      }
    }
  }
})();
